/**
 * Comparaison des soumissions — l'appel (V1.6-07).
 *
 * Une seule requête, en lecture. Il n'existe ici **aucune mutation** : cet
 * écran ne choisit pas de fournisseur, ne crée pas de prix, ne commande rien.
 * Ajouter un `useMutation` à ce module serait le premier pas vers un achat
 * fait par un écran de comparaison, et c'est précisément ce que V1.6-07 refuse.
 *
 * Le résultat n'est pas mis en cache longtemps : il dépend du besoin et des
 * soumissions validées, et les deux changent pendant qu'un acheteur travaille.
 * Mieux vaut refaire un calcul de vingt millisecondes que montrer une
 * recommandation d'il y a dix minutes.
 */
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "./client";
import type { RfqComparison, Uuid } from "./types";

export const comparisonKeys = {
  forRfq: (id: Uuid) => ["rfqs", id, "comparison"] as const,
};

export function useRfqComparison(rfqId: Uuid | undefined) {
  return useQuery({
    queryKey: comparisonKeys.forRfq(rfqId ?? ""),
    queryFn: () => apiFetch<RfqComparison>(`/rfqs/${rfqId}/comparison`),
    enabled: Boolean(rfqId),
    staleTime: 0,
  });
}
